var React = require('react');

function DepartureArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFF","cx":"32","cy":"32","r":"31.22","key":0}),React.createElement("path",{"fill":"#E6E6E6","d":"M32 64C14.354 64 0 49.646 0 32S14.354 0 32 0s32 14.354 32 32-14.354 32-32 32zm0-62.439C15.216 1.561 1.561 15.216 1.561 32S15.216 62.439 32 62.439 62.439 48.784 62.439 32 48.784 1.561 32 1.561z","key":1}),React.createElement("path",{"fill":"#009245","d":"M49.084 32l-2.704 2.704-10.787-10.787 2.704-2.704z","key":2}),React.createElement("path",{"fill":"#009245","d":"M49.085 32L38.298 42.789l-2.704-2.704L46.38 29.297z","key":3}),React.createElement("path",{"fill":"#009245","d":"M14.728 30.088H46.38v3.824H14.728z","key":4})]);
}

DepartureArrow.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = DepartureArrow;

DepartureArrow.default = DepartureArrow;
